import { render } from "./voverviewfd.vue?vue&type=template&id=3f8bf81c&scoped=true"
import script from "./voverviewfd.vue?vue&type=script&lang=js"
export * from "./voverviewfd.vue?vue&type=script&lang=js"

import "./voverviewfd.vue?vue&type=style&index=0&id=3f8bf81c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8bf81c"]])

export default __exports__